import { useCallback, useEffect, useState } from 'react';
import axios from '../../../axiosConfig';

/**
 * Fetches the top-N product margins for the Finance Overview widget.
 * The full Product Margins tab uses the same endpoint via a different
 * hook (Day 5).
 */
export default function useProductMarginsPreview(period = '7d', limit = 5) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMargins = useCallback(async (p, lim) => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get('/finance/products/margins', {
        params: { period: p, limit: lim, sort: 'margin' },
      });
      setItems(res.data?.items || []);
    } catch (err) {
      const msg = err?.response?.data?.error || err?.message || 'Failed to load product margins';
      setError(msg);
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMargins(period, limit);
  }, [period, limit, fetchMargins]);

  return { items, loading, error };
}
